export default {
  modifierSelectionPriceColor: '',
  quantityDetailPadding: '0 1.5rem',
  quantityDetailMargin: '0',
};
